export const ASSESSMENT_ITEMS = [
  {
    icon: "berth",
    customLabel: "検収",
    to: "/",
  },
  {
    icon: "assessmentList",
    to: "/view",
  },
];
